<svg width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true" focusable="false">
    <path d="M3.97 3.97 L13.03 13.03 M13.03 3.97 L3.97 13.03"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
